export default __webpack_public_path__ + "static/media/await.97bca41b.png";